 
import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { plannedMaintenanceSchema } from '../../../../dashboard/components/utility/schema-defs';
import { ScheduledMaintenanceResponse } from '../../../models';
import { getScheduledMaintenance } from '../../actions/actionType/schedule-maintenance/GetScheduledMaintenanceTypes';
import {
  getScheduledMaintenanceFailure,
  getScheduledMaintenanceStart,
  getScheduledMaintenanceSuccessful
} from '../../actions/sagaActions/schedule-maintenance/GetScheduledMaintenanceSagaActions';
import {
  GetScheduledMaintenanceFailurePayload,
  GetScheduledMaintenanceRequest
} from '../../actions/types/schedule-maintenance/GetScheduledMaintenanceTypes';

/**
 * Call Get metric summary by API
 * @returns api response
 */
interface IData {
  maintenanceName: string;
  maintenanceStatus: string;
  pageNumber: number;
  pageSize: number;
  columnId: string;
  sortType: string;
}

export async function callGetScheduledMaintenanceApi(
  data: IData
) {
  const urlApi = () => {
    let url = '';
    if (data.maintenanceName && data.maintenanceStatus && data.columnId) {
      url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?maintenanceName=${data.maintenanceName}&maintenanceStatus=${data.maintenanceStatus}&page=${data.pageNumber}&size=${data.pageSize}&sort=${data.columnId},${data.sortType}`;
      return url;
    }
    if (data.maintenanceName && data.maintenanceStatus) {
      url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?maintenanceName=${data.maintenanceName}&maintenanceStatus=${data.maintenanceStatus}&page=${data.pageNumber}&size=${data.pageSize}&sort=startTimestamp,asc`;
      return url;
    }
    if (data.maintenanceName && data.columnId) {
      url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?maintenanceName=${data.maintenanceName}&page=${data.pageNumber}&size=${data.pageSize}&sort=${data.columnId},${data.sortType}`;
      return url;
    }
    if (data.maintenanceName) {
      url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?maintenanceName=${data.maintenanceName}&page=${data.pageNumber}&size=${data.pageSize}&sort=startTimestamp,asc`;
      return url;
    }
    if (data.maintenanceStatus && data.columnId) {
      url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?maintenanceStatus=${data.maintenanceStatus}&page=${data.pageNumber}&size=${data.pageSize}&sort=${data.columnId},${data.sortType}`;
      return url;
    }
    if (data.maintenanceStatus) {
      url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?maintenanceStatus=${data.maintenanceStatus}&page=${data.pageNumber}&size=${data.pageSize}&sort=startTimestamp,asc`;
      return url;
    }
    if (data.columnId) {
      url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?page=${data.pageNumber}&size=${data.pageSize}&sort=${data.columnId},${data.sortType}`;
      return url;
    }
    url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/schedule-maintenance?page=${data.pageNumber}&size=${data.pageSize}&sort=startTimestamp,asc`;
    return url;
  };
  const maintenanceUrl = urlApi();
  return apiWrapper.get<ScheduledMaintenanceResponse>(maintenanceUrl);
}

// http://10.13.1.101:80/cip/api/v2/cir/schedule-maintenance?maintenanceName=test&page=1&size=10&sort=desc&maintenanceStatus=scheduled
export function* getScheduledMaintenanceApi({
  requestObject
}: GetScheduledMaintenanceRequest) {
  yield put(getScheduledMaintenanceStart());
  try {
    const { responseBody: data, isError, error } = yield call(callGetScheduledMaintenanceApi, requestObject);

    if (isError) {
      throw error;
    }

    const apiResponse = plannedMaintenanceSchema.validate(data, {
      abortEarly: true
    });
    if (apiResponse.error) {
      throw new Error('No Response');
    } else {
      yield put(getScheduledMaintenanceSuccessful(data));
    }
  } catch (error: any) {
    const obj: GetScheduledMaintenanceFailurePayload = {
      error: 'Unable to load Scheduled Maintenance Service'
    };
    yield put(getScheduledMaintenanceFailure(obj));
  }
}
/**
 * Saga Effect to consider latest request
 */
export function* GetScheduledMaintenanceSaga() {
  yield takeLatest(
    getScheduledMaintenance.FETCH_SCHEDULED_MAINTENANCE_REQUEST,
    getScheduledMaintenanceApi
  );
}

export const getScheduledMaintenanceSaga = [fork(GetScheduledMaintenanceSaga)];
